import {SETTINGS} from '../components/Settings';
import * as modernizr from '../utils/modernizr';
import $ from "jquery";
import {EventEmitter} from "eventemitter3";
import Navigation from '../components/Navigation';
import Utils from '../utils/Utils';

const utils = new Utils();

export default class Viewport extends EventEmitter {

    constructor(controller) {
        super();
        let me = this;
        // Init Navigation
        this.navigation = new Navigation(controller, this);

        // fn bindings
        this._updateViewportDimensions = this._updateViewportDimensions.bind(this);
        this._onWindowResize = this._onWindowResize.bind(this);
        this._onWindowLoaded = this._onWindowLoaded.bind(this);
        this._onOrientationChange = this._onOrientationChange.bind(this);


        // Runtime vars
        this.small = false;
        this.tablet = false;
        this.desktop = false;
        this.width = null;
        this.height = null;
        this.isTouch = false; // TODO
        this.deviceOrientation = null;
        this.ratio = 1;

        /**
         * Basic Check for Mobile
         */
        this.isMobile = {

            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (me.isMobile.Android() || me.isMobile.BlackBerry() || me.isMobile.iOS() || me.isMobile.Opera() || me.isMobile.Windows());
            }
        }


        // Trigger initial measurement
        this._onWindowResize();
        // Window resize listeners
        me._updateViewportDimensions();
        window.addEventListener('resize', (e) => {
            this._onWindowResize(e)
        })

        // Orientation change listener
        window.addEventListener("orientationchange", this._onOrientationChange);
        this._onOrientationChange(); // force trigger
        // Window loaded
        $(window).on('load', this._onWindowLoaded);
    }


    // -------------------------------------------------------
    // Private


    _onWindowLoaded() {
        // Notify
        this.emit('viewport.ready');
    }


    /**
     * On resize, update viewport
     */
    _onWindowResize() {
        let me = this;
        // do not trigger the event every frame...
        utils.debounce(() => {
            me._updateViewportDimensions();
            me.emit('viewport.resize', this);
        }, 500, utils.uuidv4())
    }


    /**
     * Orientation Change Event
     * @private
     */
    _onOrientationChange() {
        this.emit('orientationchange', screen.orientation);
    }



    /*
  * Get Viewport Dimensions
  * returns object with viewport dimensions to match css in width and height properties
  * ( source: http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript )
  */
    _updateViewportDimensions() {
        let w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight,
            small, tablet, desktop;

        if (x < SETTINGS.BREAKPOINTS.small) {
            small = true;
            tablet = false;
            desktop = false;
        } else if (x > SETTINGS.BREAKPOINTS.small && x <= SETTINGS.BREAKPOINTS.tablet) {
            small = false;
            tablet = true;
            desktop = false;
        } else if (x > SETTINGS.BREAKPOINTS.tablet) {
            small = false;
            tablet = false;
            desktop = true;
        }


        this.width = x;
        this.height = y;
        this.small = small;
        this.tablet = tablet;
        this.desktop = desktop;
        this.ratio = x / y;


    }


}
